module.exports = __webpack_public_path__ + "media/src/assets/Images/Itau-d5cc30bf5104a90d724ac0e8ca4bd9e0.svg";